<template>
  <div>
    <div class="preview-container bottom-shadow p-2">
      <vue-scroll
        :ops="scrollOptions"
      >
        <table
          class="table table-light bold-header"
        >
          <tr
            v-for="(row, index) in rows"
            :key="index"
          >
            <component
              :is="index === 0 && hasHeader ? 'th' : 'td'"
              v-for="(column, i) in (row)"
              :key="i"
            >
              {{ column }}
            </component>
          </tr>
        </table>
      </vue-scroll>
    </div>
  </div>
</template>
<style lang="scss">
  .preview-container {
    height: 25vh;

    .table {
      width: max-content;
    }
  }
</style>
<script>
  import VueScroll from 'vuescroll'

  export default {
    components: {
      VueScroll
    },
    props: {
      rows: {
        type: Array,
        required: true
      },
      hasHeader: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        scrollOptions: {
          bar: {
            background: 'var(--lingusta-green)',
            keepShow: true,
            minSize: 0.2
          },
          scrollPanel: {
            easing: 'easeInOutCubic',
          },
          rail: {
            size: '12px'
          }
        }
      }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
    }
  }
</script>